/// <reference types="./copilot.d.mts" />
import * as $copilot_message from "../../../common/data/copilot_message.mjs";
import * as $metadata from "../../../common/data/copilot_message/metadata.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
} from "../../gleam.mjs";

export class Copilot extends $CustomType {
  constructor(input, loading, tags, threads) {
    super();
    this.input = input;
    this.loading = loading;
    this.tags = tags;
    this.threads = threads;
  }
}

export class Thread extends $CustomType {
  constructor(id, title, messages) {
    super();
    this.id = id;
    this.title = title;
    this.messages = messages;
  }
}

export function new$() {
  return new Copilot("", false, toList([]), toList([]));
}

export function get_last_assistant_message(copilot, thread_id) {
  return $result.try$(
    $list.key_find(copilot.threads, thread_id),
    (thread) => {
      return $list.fold_until(
        thread.messages,
        new Error(undefined),
        (_, message) => {
          let $ = message.metadata;
          if ($ instanceof $metadata.Assistant) {
            let $1 = $.content;
            if ($1 instanceof Some) {
              let content = $1[0];
              return new $list.Stop(new Ok(content));
            } else {
              return new $list.Continue(new Error(undefined));
            }
          } else {
            return new $list.Continue(new Error(undefined));
          }
        },
      );
    },
  );
}

function extract_thread_title(thread) {
  let _record = thread;
  return new Thread(
    _record.id,
    (() => {
      let _pipe = $list.last(thread.messages);
      let _pipe$1 = $result.map(
        _pipe,
        (m) => { return $copilot_message.content(m); },
      );
      return $result.unwrap(_pipe$1, "");
    })(),
    _record.messages,
  );
}

function upsert_message(qs, message) {
  if (qs instanceof $Empty) {
    return toList([message]);
  } else {
    let q = qs.head;
    if (q.id === message.id) {
      let rest = qs.tail;
      return listPrepend(message, rest);
    } else {
      let q$1 = qs.head;
      let rest = qs.tail;
      return listPrepend(q$1, upsert_message(rest, message));
    }
  }
}

function upsert_thread_message(thread, message) {
  let _pipe = thread.messages;
  let _pipe$1 = upsert_message(_pipe, message);
  let _pipe$2 = $list.sort(
    _pipe$1,
    (a, b) => { return $timestamp.compare(b.created_at, a.created_at); },
  );
  let _pipe$3 = ((messages) => {
    let _record = thread;
    return new Thread(_record.id, _record.title, messages);
  })(_pipe$2);
  return extract_thread_title(_pipe$3);
}

export function add_messages(copilot, messages) {
  let _record = copilot;
  return new Copilot(
    _record.input,
    _record.loading,
    _record.tags,
    $list.fold(
      messages,
      copilot.threads,
      (threads, message) => {
        let _pipe = $list.key_find(threads, message.thread_id);
        let _pipe$1 = $result.unwrap(
          _pipe,
          new Thread(message.thread_id, "", toList([])),
        );
        let _pipe$2 = upsert_thread_message(_pipe$1, message);
        return ((_capture) => {
          return $list.key_set(threads, message.thread_id, _capture);
        })(_pipe$2);
      },
    ),
  );
}

export function is_thread_loading(thread) {
  let $ = thread.messages;
  if ($ instanceof $Empty) {
    return true;
  } else {
    let $1 = $.head;
    if ($1 instanceof $copilot_message.CopilotMessage) {
      let metadata = $1.metadata;
      if (metadata instanceof $metadata.Assistant) {
        let $2 = metadata.tool_calls;
        if ($2 instanceof $option.None) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}

export function is_input_disabled(thread) {
  if (thread instanceof $option.Some) {
    let thread$1 = thread[0];
    return is_thread_loading(thread$1) || $list.any(
      thread$1.messages,
      (message) => { return $metadata.is_deprecated(message.metadata); },
    );
  } else {
    return false;
  }
}
